import { graphql } from "@/graphql/generated";
import { MunicipalPropertyYearQuery, MunicipalPropertyYearQueryVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const MUNICIPAL_PROPERTY_YEAR_QUERY_DOCUMENT: TypedDocumentNode<MunicipalPropertyYearQuery, MunicipalPropertyYearQueryVariables> = graphql(/* GraphQL */ `
    query MunicipalPropertyYear($id: ID!, $inventoryId: ID) {
      municipalPropertyYear(id: $id, inventoryId: $inventoryId) {
        id
        registerId
        propertyId
        name
        year
        effectiveYear
        municipalityId
        municipalityName
        type
        energyTotalJ
        waterTotalM3
        valueList {
          id
          sectorKey
          subsectorKey
          energySourceKey
          amount
          dataSource
          gpcQualityRating
        }
      }
    }
  `);
